import React, {useEffect, useState} from 'react';
import './pages/Login/Login.css';
import {Route, useLocation} from 'react-router-dom';
import Navbar from "./components/Navbar/Navbar";
import {getUserPermission, handleLogout, handleSubmitLogin} from "./services/auth-service";
import {Cookies} from "react-cookie";
import Sidebar from "./components/Sidebar/Sidebar";
import {enableBanjercito} from "./index";
import Login from "./pages/Login/Login";
import IndividualQuoter from './pages/Quoter/IndividualQuoter';

const App = () => {

    const isAuthenticated = localStorage.getItem("isAuthenticated");
    const cookies = new Cookies();
    let userId = cookies.get('auditId');
    let location = useLocation();
    const [userPermissions, setUserPermissions] = useState([]);
    const defaultPermissions = [0, 1, 0, 0, 1]; //Public user permissions
    /*
    0-Consultar
    1-Exportar (Descargas de PDF)
    2-Emitir
    3-Pagar
    4-Cotizar
    * */

    useEffect(() => {
        /* To access as a public or default customer we use a default login in the main
        * page /cotizador that is launched in automatic only if we are located at the route.
        *
        * When we access like this we also send the default userId and poolCustomerId to the
        * services used in the functions getUserPermission and getUserConfiguration located in
        * App.jsx and IndividualQuoter.jsx files in useEffect function.
        */
        if (location.pathname === '/cotizador') handleSubmitLogin("default","default","1", true)
        // 43277 = user: default (For ISSFAM default)
        getUserPermission(userId ?? 43277).then(permissions => {
            setUserPermissions(permissions[39] ?? defaultPermissions)
        })
    }, [location]);

    return (
        <React.Fragment>             
            <Navbar/>                       
            <Sidebar userPermissions={userPermissions}/>        
        </React.Fragment>
    )
}


export default App;